import React from 'react';
import DimensionByYearReport from './DimensionByYearReport';

export default function RegionByYear() {
  return <DimensionByYearReport title="Sales by region" dimension="byRegion" rowLabel="Region" />;
}
